import { render } from "./Prescriptions.vue?vue&type=template&id=572a6412&scoped=true"
import script from "./Prescriptions.vue?vue&type=script&lang=js"
export * from "./Prescriptions.vue?vue&type=script&lang=js"

import "./Prescriptions.vue?vue&type=style&index=0&id=572a6412&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572a6412"]])

export default __exports__